import React, { useState } from 'react';
import { ScraperOrchestration } from '../components/ScraperOrchestration.tsx';
import { ScraperReports } from '../components/ScraperReports.tsx';
import { Navigation } from '../components/Navigation.tsx';
import { DashboardErrorBoundary } from '../components/DashboardErrorBoundary.tsx';
import './ScrapersDashboard.css';

export const ScrapersDashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'orchestration' | 'reports'>('orchestration');

  return (
    <div className="scrapers-dashboard">
      <Navigation />
      <div className="dashboard-header">
        <h1>Scrapers Dashboard</h1>
        <div className="tab-navigation">
          <button
            className={`tab-button ${activeTab === 'orchestration' ? 'active' : ''}`}
            onClick={() => setActiveTab('orchestration')}
          >
            Orchestration
          </button>
          <button
            className={`tab-button ${activeTab === 'reports' ? 'active' : ''}`}
            onClick={() => setActiveTab('reports')}
          >
            Reports
          </button>
        </div>
      </div>

      <div className="dashboard-content">
        <DashboardErrorBoundary title="Scrapers panel crashed">
          {activeTab === 'orchestration' && <ScraperOrchestration />}
          {activeTab === 'reports' && <ScraperReports />}
        </DashboardErrorBoundary>
      </div>
    </div>
  );
};

export default ScrapersDashboard;
